import { render, staticRenderFns } from "./TaxPph23.vue?vue&type=template&id=0ef3f37b"
import script from "./TaxPph23.vue?vue&type=script&lang=js"
export * from "./TaxPph23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports